import React, {useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Pdf from "react-to-pdf";
import './pdfStyle.css';
import moment from 'moment/moment';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';
import { Grid, Container, Typography, Link, Stack, Button, Card, TextField, Checkbox, FormControlLabel, Autocomplete, InputLabel, MenuItem, FormControl } from '@mui/material';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Icon from '@mui/material/Icon';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import JSON_CONST from '../../../components/CONSTVALUE.json';
import Loader from '../../Loader/Loader';

const ref = React.createRef();

// Register fonts
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#FFFFFF',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function PDFRenderDepositOfPayment (props) {
    const ref = React.createRef();
    const params = useParams()
    const [paramsData, setParamsData] = useState(params.data && JSON.parse(decodeURI(params.data)));
    const [resData, setResData] = useState([]);

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [dd, setDD] = useState({
        pageOrientation: 'landscape',
        pageSize: 'A4',
        pageMargins: [ 10, 10, 10, 10 ],
        content: [
            {text: 'INTELLECTIVE LAW OFFICES', style: 'header'},
            {text: 'Advicates, Legal Advisers & Consultants', style: 'headerSub'},
            {text: `Deposit Of Payment Wise Report:-             From: ${moment(paramsData?.from).format('DD-MM-YYYY')} To: ${moment(paramsData?.to).format('DD-MM-YYYY')}`, style: 'subheader'},
            {
                style: 'tableExample',
                table: {
                    body: [
                        [
                            {text: 'Sr', style: 'tableHeaderMain'}, 
                            {text:'Transaction No', style: 'tableHeaderMain'}, 
                            {text:'Receipt Date', style: 'tableHeaderMain'}, 
                            {text: 'Bank APS NO', style: 'tableHeaderMain'}, 
                            {text: 'Customer Name', style: 'tableHeaderMain'}, 
                            {text:'Phone', style: 'tableHeaderMain'}, 
                            {text:'Address', style: 'tableHeaderMain'}, 
                            {text:'Builder', style: 'tableHeaderMain'}, 
                            {text:'Executive', style: 'tableHeaderMain'}, 
                            {text:'Date of Deposit', style: 'tableHeaderMain'}, 
                            {text:'Ack Received', style: 'tableHeaderMain'}, 
                            {text:'Ack Filed', style: 'tableHeaderMain'}, 
                            {text:'Status', style: 'tableHeaderMain'},
                            {text:'Remark', style: 'tableHeaderMain'}
                        ],
    
                        [
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                            {text: 'OK', style: 'tableHeader'},
                        ]
                    ]
                }
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
                alignment: 'center'
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            subheadingTable: {
                fontSize: 10,
                bold: false,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                fontSize: 8,
                color: 'black',
                margin: [0, 0, 0, 0],
            },
            tableHeaderMain: {
                bold: true,
                fontSize: 10,
                color: 'black',
                margin: [0, 0, 0, 0],
            },
            tableHeaderAppNo: {
                fontSize: 6,
                color: 'black',
                margin: [0, 0, 0, 0],
            },
            tableHeaderAppNoWidth: {
                fontSize: 6,
                // maxWidth: '50px',
                color: 'black',
                margin: [0, 0, -5, 0],
            },
            headerSub: {
                fontSize: 16,
                alignment: 'center'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
        }
        
    });

    const exportToExcel = async () => {
    if (resData.length === 0) {
        alert("No data available to export!");
        return;
    }

    // Define the header
    const header = [
        ["INTELLECTIVE LAW OFFICES"], 
        ["Advocates, Legal Advisers & Consultants"],
        [`Deposit Of Payment Wise Report: From: ${moment(paramsData?.from).format('DD-MM-YYYY')} To: ${moment(paramsData?.to).format('DD-MM-YYYY')}`],
        [] // Empty row for spacing
    ];

    // Convert the data to a worksheet
    const data = XLSX.utils.json_to_sheet(resData, { origin: 4 }); // Start data from row 5

    // Merge the headers with the data
    const ws = XLSX.utils.sheet_add_aoa(data, header, { origin: "A1" });

    // Apply styling for the header
  // eslint-disable-next-line dot-notation
ws["A1"].s = { font: { bold: true, sz: 16 }, alignment: { horizontal: "center" } };
// eslint-disable-next-line dot-notation
ws["A2"].s = { font: { italic: true, sz: 12 }, alignment: { horizontal: "center" } };
// eslint-disable-next-line dot-notation
ws["A3"].s = { font: { bold: true, sz: 10 }, alignment: { horizontal: "center" } };

    // Merge cells for the header
    ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }, // Merge "INTELLECTIVE LAW OFFICES"
        { s: { r: 1, c: 0 }, e: { r: 1, c: 10 } }, // Merge "Advocates, Legal Advisers & Consultants"
        { s: { r: 2, c: 0 }, e: { r: 2, c: 10 } }  // Merge "Deposit Of Payment Wise Report"
    ];

    // Set column widths for readability
    ws['!cols'] = [
        { wpx: 50 },  // Sl No
        { wpx: 120 }, // Transaction No
        { wpx: 100 }, // Receipt Date
        { wpx: 100 }, // Bank Ref
        { wpx: 150 }, // Bank
        { wpx: 100 }, // Branch
        { wpx: 180 }, // Customer Name
        { wpx: 200 }, // Payment Details
        { wpx: 220 }, // Property Address
        { wpx: 150 }, // Builder Name
        { wpx: 100 }, // Phone No
        { wpx: 150 }, // Executive Name
        { wpx: 120 }, // Date of Deposit
        { wpx: 200 }, // Receipt Particulars
        { wpx: 120 }, // Date Receipt Sent to Bank
        { wpx: 100 }, // Case Close
        { wpx: 100 }, // Acknowledgment Received
        { wpx: 100 }, // Acknowledgment Filed
        { wpx: 100 }, // Status
        { wpx: 100 }, // Volume Number
        { wpx: 100 }, // Serial Number
        { wpx: 250 }  // Remarks
    ];

    // Create a workbook and save the file
    const wb = { Sheets: { 'Deposit Report': ws }, SheetNames: ['Deposit Report'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const fileData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(fileData, `Deposit_Report_${moment().format('YYYYMMDD')}${fileExtension}`);
};

    const exportToPdf = (value) => {
        pdfMake.createPdf(value).open();
    }

    

    useEffect(() => {

        // ADD TO ROW FOR THE PDF
        const tableHeadder = [];
        tableHeadder.push(dd.content[3].table.body[0]);
        console.log('1',dd)
        const fullDD = dd;
        let fullData = [];
        const pushToMain = tableHeadder;
        setIsLoading(true);

        try {
            axios.post(`${JSON_CONST.DB_URL}depositOfPayment/registrationGlobalREport`, paramsData)
                .then((response) => {
                    console.log(response);
                    response.data.sort((a, b) => a.bankName.name.localeCompare(b.bankName.name));
                    response.data.forEach((row, index) => {
                        fullData = [];

                        const addLineBreaks = (str) => {
                            let result = '';
                            while (str.length > 0) {
                                result += `${str.substring(0, 35)  }\n`;
                                str = str.substring(10);
                            }
                            return result.trim();
                        };

                        // Push to Temp
                        fullData.push({text: index + 1, style: 'tableHeaderAppNo'})
                        fullData.push({text: row.id, style: 'tableHeaderAppNo'})
                        fullData.push({text: moment(row?.reciptDate).format('DD-MM-YYYY'), style: 'tableHeader'})
                        fullData.push({text: row?.refNo, style: 'tableHeaderAppNo'})
                        fullData.push({text: row?.bankName?.name, style: 'tableHeaderAppNo'})
                        fullData.push({text: row?.phoneNo, style: 'tableHeaderAppNo'})
                        fullData.push({text: addLineBreaks(row?.address), style: 'tableHeaderAppNo'})
                        fullData.push({text: addLineBreaks(row?.builderName), style: 'tableHeaderAppNo'})
                        fullData.push({text: row?.handledByName?.name, style: 'tableHeaderAppNo'})
                        fullData.push({text: moment(row?.DateofDeposit).format('DD-MM-YYYY'), style: 'tableHeader'})
                        fullData.push({text: row?.AckReceived, style: 'tableHeaderAppNo'})
                        fullData.push({text: addLineBreaks(row?.AckFiled), style: 'tableHeaderAppNo'})
                        fullData.push({text: row?.statusValue, style: 'tableHeaderAppNo'})
                        fullData.push({text: addLineBreaks(row?.remarks), style: 'tableHeaderAppNo'})

                        // Push To Main
                        pushToMain.push(fullData)
                    });

                    // assign main Value
                    fullDD.content[3].table.body = pushToMain;
                    setDD(fullDD);
                    
                    const resDataConst = response.data;
                    const setXL = [];
                    resDataConst.forEach((row, index) => {
                        const setXLSX = {
                            'Sl No': index + 1,
                            'Transaction No': row.id,
                            'Receipt date': row.reciptDate ? moment(row.reciptDate).format('DD-MM-YYYY') : '',
                            'Bank Ref': row.refNo,
                            'Bank ': row?.bankName?.name,
                            'Branch': row?.branchName?.name,
                            'Customer name': row.customerBorrower,
                            'Payment details': row.paymentDetails,
                            'Property Address': row.address,
                            'Builder name': row.builderName,
                            'Phone No': row.phoneNo,
                            'Executive Name': row?.handledByName?.name,
                            'Date of Deposit': row.DateofDeposit ? moment(row.DateofDeposit).format('DD-MM-YYYY') : '',
                            'Receipt Particulars': row.Receiptparticulars,
                            'Date receipt sent to Bank': row.dateReceiptSentToBank ? moment(row.dateReceiptSentToBank).format('DD-MM-YYYY') : '',
                            'Case close': row.CaseClosed,
                            'Acknowledgment received': row.AckReceived,
                            'Acknowledgment': row.AckFiled,
                            'Status': row.statusValue,
                            'Volume number': row.volNo,
                            'Serial number': row.sn,
                            'Remarks': row.remarks,
                        }

                        setXL.push(setXLSX)
                    })                    
                    setResData(setXL)
                    setIsLoading(false);

                }).catch((error) => {
                    console.log(error);
                    setIsLoading(false);

                });
        }
        catch (err) {
            console.log(err)
            setIsLoading(false);

        }
    }, [dd, dd.content, paramsData]);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate()
    const redirectPage = async (url) => {
        navigate(`/app/${url}`, { replace: true });
      };
    return (
        <>
            {isLoading ? (
                <Loader />
                ) : (
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2}>
                        <Grid item xs={12}>
                        <Button style={{backgroundColor: 'black', color: 'white'}} onClick={(e) => redirectPage('reportDisbursal/depositOfPayment/0')} size="medium"> ← Back</Button>
                        </Grid>
                            <Grid item xs={6}>
                            <Item style={{backgroundColor: '#FFFFFF',display: 'flex', justifyContent: 'right', marginTop: '150px'}}>
                                <Card style={{backgroundColor: '#B14019'}} sx={{ minWidth: 345 }}>
                                    <CardMedia
                                        sx={{ height: 140 }}
                                        image={''}
                                        title=""
                                    >
                                        <PictureAsPdfOutlinedIcon style={{marginTop: '20px', fontSize: '140px', color: 'white'}} />
                                    </CardMedia>
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div" style={{color: 'white'}}>
                                        PDF EXPORT 
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button style={{backgroundColor: '#F9F9F9'}} onClick={(e) => exportToPdf(dd)} size="small">PDF</Button>
                                        &nbsp;&nbsp;&nbsp;<sub style={{color: '#F9F9F9'}}>Click to open/download</sub>
                                    </CardActions>
                                </Card>
                            </Item>
                            </Grid>
                            <Grid item xs={6}>
                            <Item style={{backgroundColor: '#FFFFFF',display: 'flex', justifyContent: 'left', marginTop: '150px'}}>
                            <Card style={{backgroundColor: '#1C9F44'}} sx={{ minWidth: 345 }}>
                                    <CardMedia
                                        sx={{ height: 140 }}
                                        image=""
                                        title=""
                                    >
                                        <FileDownloadOutlinedIcon style={{marginTop: '20px', fontSize: '140px', color: 'white'}} />
                                    </CardMedia>
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div" style={{color: 'white'}}>
                                        XLSX EXPORT
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button style={{backgroundColor: '#F9F9F9'}} onClick={(e) => exportToExcel(e)} size="small">XLSX </Button>
                                        &nbsp;&nbsp;&nbsp;<sub style={{color: '#F9F9F9'}}>Click to open/download</sub>
                                    </CardActions>
                                </Card>
                            </Item>
                            </Grid>
                        </Grid>
                    </Box>
            )}
        </>
    )
}
